import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { useModuleActive } from "../../lib/phaseFeatures";

const msg = (e) => e?.response?.data?.detail?.message || "Could not load your field home.";
const STATE = { draft: "Draft", submitted: "Waiting for review", acknowledged: "Approved" };

// B8: field-crew home — my assigned projects, today's report, my open tasks.
export default function FieldHome() {
  const [h, setH] = useState(null);
  const [err, setErr] = useState("");
  const { user } = useAuth();
  const commsOn = useModuleActive("communications", user?.id);
  const closeoutOn = useModuleActive("closeout", user?.id);
  useEffect(() => { api.get("/field/home").then((r) => setH(r.data)).catch((e) => setErr(msg(e))); }, []);
  return (
    <AppShell title="Field" subtitle="Today on site">
      <div className="mx-auto w-full max-w-[720px] px-4 space-y-6" data-testid="field-home">
        {err && <p role="alert" className="text-sm text-red-700" data-testid="field-home-error">{err}</p>}
        {h && (<>
          <section className="space-y-2">
            <h2 className="font-heading text-lg">My projects · {h.date}</h2>
            {!h.projects.length && <p className="text-sm" data-testid="field-home-no-projects">You are not on any project team yet.</p>}
            <ul className="space-y-2">{h.projects.map((p) => (
              <li key={p.id} className="border border-erf-borderCream rounded bg-white p-3 flex flex-wrap gap-2 items-center" data-testid={`field-home-project-${p.id}`}>
                <span className="font-semibold min-w-0 break-words">{p.name}</span>
                <Link to={`/hse/projects/${p.id}`} className="text-xs underline min-h-[44px] inline-flex items-center" data-testid={`field-home-safety-${p.id}`}>Safety</Link>
                {commsOn && <Link to={`/comms/projects/${p.id}`} className="text-xs underline min-h-[44px] inline-flex items-center" data-testid={`field-home-comms-${p.id}`}>Communications</Link>}
                {closeoutOn && <Link to={`/pm/projects/${p.id}/closeout`} className="text-xs underline min-h-[44px] inline-flex items-center" data-testid={`field-home-closeout-${p.id}`}>Closeout</Link>}
                {p.can_view_reports && <span className="text-xs" data-testid={`field-home-today-${p.id}`}>{p.today_report ? STATE[p.today_report.state] : "No report today"}</span>}
                {p.today_report && <Link to={`/field/reports/${p.today_report.id}`} className="ml-auto min-h-[48px] px-4 inline-flex items-center rounded-sm border border-erf-borderCream text-sm font-semibold" data-testid={`field-home-open-${p.id}`}>Open today's report</Link>}
                {!p.today_report && p.can_write_report && <Link to={`/field/projects/${p.id}/report`} className="ml-auto min-h-[48px] px-4 inline-flex items-center rounded-sm bg-erf-dark text-white text-sm font-semibold" data-testid={`field-home-start-${p.id}`}>Start today's report</Link>}
              </li>))}
            </ul>
          </section>
          <section className="space-y-2">
            <h2 className="font-heading text-lg">My tasks</h2>
            {!h.tasks.length && <p className="text-sm" data-testid="field-home-no-tasks">No open tasks.</p>}
            <ul className="space-y-2">{h.tasks.map((t) => (
              <li key={t.id} className="border border-erf-borderCream rounded bg-white p-3 text-sm" data-testid={`field-home-task-${t.id}`}>
                {t.title} · due {t.due_date} {t.overdue && <span className="text-red-800 font-semibold">Overdue</span>}
              </li>))}
            </ul>
          </section>
          <Link to="/field/reports" className="underline text-sm inline-flex min-h-[48px] items-center" data-testid="field-home-search-link">Search past reports</Link>
        </>)}
      </div>
    </AppShell>
  );
}
